import { cn } from "@/lib/utils";

export type DashboardViewRole = "technician" | "sales";

export function DashboardRoleToggle({
  value,
  onChange,
}: {
  value: DashboardViewRole;
  onChange: (v: DashboardViewRole) => void;
}) {
  return (
    <div className="inline-flex rounded-lg border border-slate-200 bg-slate-50/80 p-0.5 text-xs font-medium">
      {(
        [
          { id: "technician" as const, label: "Technician View" },
          { id: "sales" as const, label: "Sales View" },
        ] as const
      ).map((opt) => (
        <button
          key={opt.id}
          type="button"
          onClick={() => onChange(opt.id)}
          className={cn(
            "rounded-md px-3 py-1.5 transition-colors",
            value === opt.id
              ? "bg-white text-slate-900 shadow-sm"
              : "text-slate-500 hover:text-slate-700"
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
